module.exports = __webpack_public_path__ + "media/images/aa-bk-b7989c6c85933f11bd691d99c9ff4d7f.png";